/* Use to manage API changes */

// TODO store history BEFORE and AFTER forms separately to navigate through the whole flow

import axios from "@/axios";

const preserveEndpoint = (case_id) => `case/${case_id}/preserve-ui-redirection`;

export const redirectionConfigAPI = (case_id) => {
	if (!case_id) {
		throw new Error("Case ID is required to create redirectionConfigAPI");
	}

	const url = preserveEndpoint(case_id);

	return {
		fetch(object_id) {
			return axios.get(url, {
				params: {
					object_id,
				}
			});
		},
		store(object_id, data = []) {
			return axios.post(url, {
				data,
			}, {
				params: {
					object_id,
				}
			});
		},
	}
}

export class RedirectionConfig {
	constructor(case_id, object_id) {
		this.object_id = object_id;
		this.history = [];
		this.case_id = case_id;
		this.redirectionConfigAPI = redirectionConfigAPI(case_id);
	}

	setHistory(data = []) {
		if (Array.isArray(data)) {
			this.history = data;
		} else {
			console.error("Invalid data format. Expected an array.");
		}
		return this;
	}
	addHistory(data = []) {
		if (Array.isArray(data)) {
			this.history.push(...data);
		} else {
			console.error("Invalid data format. Expected an array.");
		}
		return this;
	}
	popHistory() {
		if (this.history.length > 0) {
			return this.history.pop();
		} else {
			console.warn("No history to pop.");
			return null;
		}
	}
	async fetchHistory() {
		try {
			const { data } = await this.redirectionConfigAPI.fetch(this.object_id) || {};
			const history = data?.data || null;
			if (Array.isArray(history)) {
				this.setHistory(history);
			}
		} catch (error) {
			console.error("Error fetching redirection history:", error);
			// Uncomment to reset if fetching fails
			// // If fetching fails, reset history to an empty array
			// this.setHistory();
		}
		return this;
	}
	async storeHistory() {
		try {
			await this.redirectionConfigAPI.store(this.object_id, this.history);
		} catch (error) {
			console.error("Error storing redirection history:", error);
			// throw error;
		}
		return this;
	}

	get currentRedirectionConfig() {
		if (this.history.length > 0) {
			return this.history.at(-1);
		}
		return null;
	}
}
